import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { addRemoveError, getControl, getFormArray } from '@shared/helpers/form.helper';
import { datiBilancioCkHelper, getDatiBilancioControl, getDatiBilancioGroup } from './helpers/dati-bilancio-form.helpers';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { FormValidationError } from '@shared/models/interfaces/form-validation-error.interface';
import { toNum } from '@shared/helpers/math.helper';

export const datiBilancioContributiPubbliciRules: FormGroupRules = {
    my_lblContrPubb: (form: FormGroup) => {
        const my_lblContrPubbControl = getDatiBilancioControl(form, 'my_lblContrPubb');
        const my_CkContribPubb: string = getDatiBilancioControl(form, 'my_CkContribPubb')?.value;
        const my_ElEnteErogatore = getFormArray(getDatiBilancioGroup(form), 'my_EntiErogatori.my_ElEnteErogatore')?.value;
        const errors = my_lblContrPubbControl.errors ? my_lblContrPubbControl.errors : {};
        const showError = my_CkContribPubb === '1' && !my_ElEnteErogatore?.length;

        addRemoveError(showError, errors, 'my_lblContrPubb', {
            status: 'Inserire Ente Erogatore.',
            message: 'Almeno un ente erogatore deve essere inserito.',
        });

        my_lblContrPubbControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_Importo: (form: FormGroup) => {
        enteErogatoreHelper(form, 'my_Importo', isNilOrEmpty, 'my_Importo', { status: REQUIRED_STATUS });
    },

    my_Ente: (form: FormGroup) => {
        enteErogatoreHelper(form, 'my_Ente', isNilOrEmpty, 'my_Ente', { status: REQUIRED_STATUS });
    },

    my_Tipologia: (form: FormGroup) => {
        enteErogatoreHelper(form, 'my_Tipologia', (v) => toNum(v) === 0, 'my_Tipologia', { status: 'Valore non valido' });
    },

    my_SpecificaTipologia: (form: FormGroup) => {
        enteErogatoreHelper(form, 'my_SpecificaTipologia', (v, element) => isNilOrEmpty(v) && getControl(element, 'my_Tipologia')?.value === '6', 'my_SpecificaTipologia', {
            status: 'Campo obbligatorio per la tipologia specificata',
        });
    },

    my_DescContribPubb: (form: FormGroup) => {
        datiBilancioCkHelper(form, 'my_DescContribPubb', 'my_CkContribPubb', 1);
    },
};

const enteErogatoreHelper = (
    form: FormGroup,
    fieldPath: string,
    condition: (value: string, element: FormGroup) => boolean,
    errorKey: string,
    errorBody: FormValidationError
): void => {
    const my_CkContribPubb: string = getDatiBilancioControl(form, 'my_CkContribPubb')?.value;
    getFormArray(getDatiBilancioGroup(form), 'my_EntiErogatori.my_ElEnteErogatore').controls.forEach((element: FormGroup) => {
        const fieldControl = getControl(element, fieldPath);
        const errors = fieldControl.errors ? fieldControl.errors : {};
        addRemoveError(condition(fieldControl.value, element) && my_CkContribPubb === '1', errors, errorKey, errorBody);
        fieldControl.setErrors(isEqual(errors, {}) ? null : errors);
    });
};
